import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { SentEmail } from '../../interfaces/sent-emails/sent-email';

@Injectable()

export class SentEmailsService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<SentEmail[] | boolean> {
    return new Observable<SentEmail[] | boolean>((o: Subscriber<SentEmail[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('sent-emails.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<SentEmail[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  message(id: number): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('sent-emails.message', {':id': id}));
  }

  logs(id: number): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('sent-emails.logs', {':id': id}));
  }
}
